import React from 'react';

const Reports: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Sales Report</h3>
          </div>
          <div className="px-4 py-5 sm:p-6">
            <div className="h-64 flex items-center justify-center text-gray-500">
              Sales chart would be displayed here
            </div>
          </div>
        </div>

        <div className="card">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Inventory Report</h3>
          </div>
          <div className="px-4 py-5 sm:p-6">
            <div className="h-64 flex items-center justify-center text-gray-500">
              Inventory chart would be displayed here
            </div>
          </div>
        </div>

        <div className="card">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Financial Report</h3>
          </div>
          <div className="px-4 py-5 sm:p-6">
            <div className="h-64 flex items-center justify-center text-gray-500">
              Financial chart would be displayed here
            </div>
          </div>
        </div>

        <div className="card">
          <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Customer Report</h3>
          </div>
          <div className="px-4 py-5 sm:p-6">
            <div className="h-64 flex items-center justify-center text-gray-500">
              Customer chart would be displayed here
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;